export default (studyColumns, selectedStatus = true) => {
  const studyTypeFiltered = { ...studyColumns }
  studyTypeFiltered.columnGroups = studyColumns.columnGroups.map((columnGroup) => {
    const columnGroupFiltered = { ...columnGroup }
    columnGroupFiltered.columns = columnGroup.columns.filter((column) => column.isActive === selectedStatus )
    return columnGroupFiltered
  }).filter((columnGroup) => columnGroup.columns.length)
  return studyTypeFiltered
}